import featureFlags from "@/store/modules/feature-flags";
import opportunity from "@/store/modules/opportunity";
import services from "@/store/modules/services";
import signals from "@/store/modules/signals";
import trialFeatures from "@/store/modules/trial-features";
import users from "@/store/modules/users";
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    users,
    signals,
    trialFeatures,
    featureFlags,
    services,
    opportunity
  }
});
